module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomerOwnerDataReportTwo"
    }
  }, [_c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('div', {
    staticClass: "reportView"
  }, [_c('div', {
    staticClass: "BottomBox"
  }, [_c('div', {
    ref: "OnepieChart",
    attrs: {
      "id": "OnepieChart"
    }
  }), _vm._v(" "), _c('div', {
    ref: "Twohistogram",
    attrs: {
      "id": "Twohistogram"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "histogram"
  }, [_c('div', {
    ref: "threemyChart",
    attrs: {
      "id": "threemyChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "otherStaffs",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-radio-group', {
    class: [_vm.$route.query.identification ? 'h5Position' : 'PCposition'],
    attrs: {
      "fill": "#52D2A2",
      "size": "small"
    },
    on: {
      "change": function($event) {
        return _vm.getOtherPersonnel()
      }
    },
    model: {
      value: (_vm.OtherPersonnelType),
      callback: function($$v) {
        _vm.OtherPersonnelType = $$v
      },
      expression: "OtherPersonnelType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "CERTIFICATE_TYPE_SAFETY"
    }
  }, [_vm._v("安证人员")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "CERTIFICATE_TYPE_TITLE"
    }
  }, [_vm._v("职称人员")])], 1), _vm._v(" "), _c('div', {
    ref: "otherStaffsEchart",
    attrs: {
      "id": "otherStaffsEchart"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c2279ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportComponentPage/EliteCertificateDataReportTwo.vue
// module id = 1661
// module chunks = 471